import React from "react";
import { Link } from "react-router-dom";
const getUserColumns = () => {
  return [
    {
      title: "S.No",
      dataIndex: "id",
      render: (text, record, index) => index + 1,
      sorter: (a, b) => a.id.length - b.id.length,
      width: "10%",
    },
    {
      title: "Name",
      dataIndex: "firstName" + "surname",
      render: (_, record) => `${record.firstName} ${record.surname}`,
      width: "15%",
    },
    {
      title: "Email",
      dataIndex: "email",
      width: "15%",
    },
    {
      title: "User ID",
      dataIndex: "id",
      width: "15%",
    },
    {
      title: "Transactions Count",
      dataIndex: "transactionCount",
      render: (transactionCount, record) => (
        <Link to={`/ChargingHistory/${record?.id}`}>{transactionCount}</Link>
      ),
      width: "15%",
    },
    {
      title: "Cards Count",
      dataIndex: "cardCount",
      render: (cardCount, record) => (
        <Link to={`/cards/${record?.id}`}>{cardCount}</Link>
      ),
      width: "15%",
    },
    // {
    //   title: "Action",
    //   className: "text-end",
    //   render: (text, record) => (
    //     <div className="dropdown dropdown-action text-end">
    //       <Link
    //         to="#"
    //         className="action-icon dropdown-toggle"
    //         data-bs-toggle="dropdown"
    //         aria-expanded="false"
    //       >
    //         <i className="material-icons">more_vert</i>
    //       </Link>
    //       <div className="dropdown-menu dropdown-menu-right">
    //         <Link className="dropdown-item" to={`/addUser/${record?.id}`}>
    //           <i className="fa fa-pencil m-r-5" /> Edit
    //         </Link>
    //         <button
    //           className="dropdown-item"
    //           //   onClick={() => deleteFunc(record.id)}
    //         >
    //           <i className="fa fa-trash m-r-5" /> Delete
    //         </button>
    //       </div>
    //     </div>
    //   ),
    //   width: "15%",
    // },
  ];
};

export default getUserColumns;
